import axios from "../http";
let module = "/sysUserRole";
function listRole(data){
  return axios.get(module +'/listRole',{params:data});
}
function listUserRoleRelation(id){
  return axios.get(module + "/" + id);
}
function saveUserRoleRelation(data){
  return axios.put(module + '/userRoleRelation',data);
}



export default {
  listRole,
  listUserRoleRelation,
  saveUserRoleRelation
}
